import {Injectable, Injector} from '@angular/core';
import {PersonasLoadRequestAction} from '../store/entities/shared/personas/personas.actions';
import {EmpresasLoadRequestAction} from '../store/entities/shared/empresas/empresas.actions';
import {Store} from '@ngrx/store';
import {AppState} from '../../core/store/core.state';
import {
  RolesLoadRequestAction,
  RolesLoadSuccessAction
} from '../store/entities/shared/roles/roles.actions';
import {SocketService} from "../../shared/services/socket.service";
import {ChacraService} from "../../chacra-core/services";
import {RolService} from "../../core/services";
import {Rol} from "../../core/enums";
import {ChacrasGeoLoadRequestAction} from "../store/entities/shared/chacras-geo/chacras-geo.actions";
import {ChacraGeoFrom} from "../../chacra-core/models/chacra";
import {CultivosLoadRequestAction} from "../store/entities/shared/cultivos/cultivos.actions";
import {RolesArcgisLoadRequestAction} from "../store/entities/shared/roles-arcgis/roles-arcgis.actions";

@Injectable({
  providedIn: 'root'
})
export class LoadDataService {

  socketAttachServices = {
    'load-suelos': {target: ChacraService, method: 'LoadSuelos'},
  };

  constructor(private store: Store<AppState>,
              private socketService: SocketService,
              private rolService: RolService,
              private injector: Injector,) {
  }

  load(): void {

    //Core
    this.store.dispatch(new CultivosLoadRequestAction());
    this.store.dispatch(new PersonasLoadRequestAction());
    // this.store.dispatch(new AdjuntosLoadRequestAction());

    if(this.rolService.isUserFree()){
      this.store.dispatch(new RolesLoadSuccessAction({
        items: [{rolId: Rol.USUARIO_LIBRE, rolNombre: 'Usuario Libre'}]
      }));
    }
    else{

      // mapa
      this.store.dispatch(new ChacrasGeoLoadRequestAction([
        ChacraGeoFrom.AGLUTINADOR_POINT,
        ChacraGeoFrom.AGLUTINADOR_POLYGON,
        ChacraGeoFrom.AGLUTINADOR_PADRON,
        ChacraGeoFrom.ASEGURADORA_POINT,
        ChacraGeoFrom.ASEGURADORA_POLYGON,
        ChacraGeoFrom.ASEGURADORA_PADRON,
      ]));

      if(this.rolService.isAuditor()){
        // this.store.dispatch(new RolesLoadSuccessAction({
        //   items: [{rolId: Rol.DGRN, rolNombre: 'DGRN'}]
        // }));
        this.store.dispatch(new RolesLoadRequestAction());
        this.store.dispatch(new RolesArcgisLoadRequestAction());
      }

      if(this.rolService.isAglutinadora() || this.rolService.isAseguradora() || this.rolService.isProductor()){
        this.store.dispatch(new RolesLoadRequestAction());
        this.store.dispatch(new RolesArcgisLoadRequestAction());
        this.store.dispatch(new EmpresasLoadRequestAction());
      }

    }

    this.reciveSocketConn();
  }

  reciveSocketConn() {
    const obs = this.socketService.socketGetData();
    if(obs){
      obs.subscribe((response => {
        let attach = this.socketAttachServices[response.type];
        if(attach){
          let lazyService = this.injector.get(attach.target);
          lazyService[attach.method](response.data);
        }
      }));
    }
  }
}
